export class Query {
  public static INDIVIDUAL_SITE_DESIGN: any = {
    variables: {},
    query: `query individualSite($siteId: uuid!) {
      site(where: {id: {_eq: $siteId}}) {
        physicalAddressId: site_address_id
        tonerAddressId: toner_address_id
        serviceAddressId: service_address_id
        hpInstalledKit: hp_installed_kit
        tmcSiteName: name
        address {
          siteId: itsm_site_id
        }
        project {
          global_deal_settings {
            projectCostCenter {
              cost_centers
            }
          }
          defaultCustomShippingLabel1: custom_label_1
          defaultCustomShippingLabel2: custom_label_2
          target_system
          customerContractAccounts {
            contract_accounts
          }
          partnerContractAccounts {
            contract_accounts
          }
          customHeaders: account_custom_labels
          opportunityId: opportunity_id
        }
      }
    }`,
  };

  public static CA: any = {
    variables: {},
    query: `query contractAccount($projectId: uuid!) {
    project(where: {id: {_eq: $projectId}}) {
      target_system
      pending_contract_accounts {
        contractAccountName: ca_name
        caStatus: status
        billToParty: bill_to_bpid
        alternatePayer: payer_bpid
      }
      partnerContractAccounts {
        contract_accounts
      }
      customerContractAccounts {
        contract_accounts
      }
    }
  }`,
  };

  public static DEPLOY_DEVICE: any = {
    variables: {},
    query: `query globaldeal($projectId: uuid!) {
      global_deal_settings(where: {project_id: {_eq: $projectId}}) {
        projectCostCenter {
          cost_centers
        }
        project {
          target_system
          partnerContractAccounts {
            contract_accounts
          }
          customerContractAccounts {
            contract_accounts
          }
          defaultCustomShippingLabel1: custom_label_1
          defaultCustomShippingLabel2: custom_label_2
          customHeaders: account_custom_labels
          opportunityId: opportunity_id
          currentMaStatus: cur_master_agreement_status
          projectStatus: status 
          billFromStructure: bill_from_structure
        }
      }
    }`,
  };

  public static PROJECT: any = {
    variables: {},
    query: `query project($projectId: uuid!) {
      project(where: {id: {_eq: $projectId}}) {
        id
        billFromStructure: bill_from_structure
        countryId: country_id
        targetSystem: target_system
        itsmCustomerId: itsm_customer_id
        resellerCustomerId: reseller_customer_id
        startDate: start_date
        name: name
        enableBulkOrdering: enable_bulk_ordering
        installationInstructions: installation_instructions
        purchaseOrderSplit: purchase_order_split
        defaultContractAccountId: default_contract_account_id
        country {
          countryId: country_id
          countryName: country_name
          geo_region_id
        }
        fleetId: fleet_id
        fleetName: fleet_name
        customerName: customer_name
        holdDate: hold_date
        status: status
        partnerPurchaseOrders: partner_purchase_orders
        dashboardIssues: dashboard_issues
        expenses: expenses
        dashboardMilestones: dashboard_milestones
        qualityChecklist: quality_checklist
        installationInstructions: installation_instructions
        customerBpId: customer_bpid
        resellerName: reseller_name
        resellerBpId: reseller_bpid
        opportunityId: opportunity_id
        uniqueId: unique_id
        sourceDocumentationLink: source_documentation_link
        customerKickoffDate: customer_kickoff_date
        estimatedCompletionDate: estimated_completion_date
        estimatedProjectClosureDate: estimated_project_closure_date
        actualProjectClosureDate: actual_project_closure_date
        enableBulkOrdering: enable_bulk_ordering
        totalCustomerValue: total_customer_value
        requireMaiPagecounts: require_mai_pagecounts
        currency: currency
        customerPin: customer_pin
        sourceName: source_name
        deliveryInformation: delivery_information
        workspaces: workspaces
        supplyRoutingId: supply_routing_id
        billToAddress: address {
          id
          name1
          name2
          line1
          line2
          city
          region
          postalCode: postal_code
          country {
            country_name
            created_at
            geo_region_id
            updated_at
          }
          customShippingLabel1: custom_label_1
          customShippingLabel2: custom_label_2
          deliveryType: delivery_type
          businessPartnerId: business_partner_id
          itsmSiteId: itsm_site_id
          itsmSiteName: itsm_site_name
          itsmBuildingId: itsm_building_id
          itsmBuilding: itsm_building
          buildingTypes: building_types
        }
        payerAddress: addressByPayerAddressId {
          id
          name1
          name2
          line1
          line2
          city
          region
          postalCode: postal_code
          country {
            country_name
            created_at
            geo_region_id
            updated_at
          }
          customShippingLabel1: custom_label_1
          customShippingLabel2: custom_label_2
          deliveryType: delivery_type
          businessPartnerId: business_partner_id
          itsmSiteId: itsm_site_id
          itsmSiteName: itsm_site_name
          itsmBuildingId: itsm_building_id
          itsmBuilding: itsm_building
          buildingTypes: building_types
        }
        soldToAddress: addressBySoldToAddressId {
          id
          name1
          name2
          line1
          line2
          city
          region
          postalCode: postal_code
          country {
            country_name
            created_at
            geo_region_id
            updated_at
          }
          customShippingLabel1: custom_label_1
          customShippingLabel2: custom_label_2
          deliveryType: delivery_type
          businessPartnerId: business_partner_id
          itsmSiteId: itsm_site_id
          itsmSiteName: itsm_site_name
          itsmBuildingId: itsm_building_id
          itsmBuilding: itsm_building
          buildingTypes: building_types
        }
        hpContractAdminContact: contactByHpContractAdminContactId {
          businessPartnerId: business_partner_id
        }
        endUserAddress: addressByEndUserAddressId {
          id
          name1
          name2
          line1
          line2
          city
          region
          postalCode: postal_code
          country {
            country_name
            created_at
            geo_region_id
            updated_at
          }
          customShippingLabel1: custom_label_1
          customShippingLabel2: custom_label_2
          deliveryType: delivery_type
          businessPartnerId: business_partner_id
          itsmSiteId: itsm_site_id
          itsmSiteName: itsm_site_name
          itsmBuildingId: itsm_building_id
          itsmBuilding: itsm_building
          buildingTypes: building_types
        }
        customShippingLabel1: custom_label_1
        customShippingLabel2: custom_label_2
        isFedLLC: elevated_privilege
        customLabels: account_custom_labels
        currentMaStatus: cur_master_agreement_status
        isMpc: is_mpc
      }
    }`,
  };

  public static DEPLOY_ADDRESS: any = {
    variables: {},
    query: `query siteBuildingAddress($siteId: [String!]) {
      settableAddresses: building_address(distinct_on:itsmBuilding
        where:{
          itsmSiteId:{
            _in:$siteId
          }
        }){
          itsmSiteAddressId: itsmSiteId
            itsmSiteName: itsmSiteName
            buildingTypes: building_types
            itsmSiteId: itsmSiteId
            itsmBuilding: itsmBuilding
            itsmName: itsmBuilding
            itsmBuildingId: itsmBuildingId
            customShippingLabel1: customShippingLabel1
            customShippingLabel2: customShippingLabel2
            deliveryType: deliveryType
            name1
            name2
            line1
            line2
            city
            region
            postalCode: postalCode
            country: country
            businessPartnerId: businessPartnerId
            id
        }
    }`,
  };

  public static SITE_DEPLOYMENT: any = {
    variables: {},
    query: `query siteDeployment($id: uuid!) {
      site_deployment(where: {id: {_eq: $id}}) {
        assets {
          site {
            service_address_id
            toner_address_id
            site_address_id
            address {
              itsm_site_id
            }
          }
        }
      }
    }`
  };

  public static PO: any = {
    variables: {},
    query: `query purchaseOrder($projectId: uuid!) {
      purchase_order(where: {project_id: {_eq: $projectId}}) {
        id
        itsmId: itsm_id
        isInItsm: is_in_itsm
        purchaseOrderNumber: purchase_order_number
        purchaseOrderDescription: purchase_order_description
        isSelected: is_selected
        createdOn: created_on_in_itsm
        dartOffers: dart_offers
        preloadData: preload_data
        projectId: project_id
        monthlyPo: monthly_po
      }
    }`,
  };

  public static SAVE_AREA_GROUP: any = {
    variables: {},
    query: `mutation ($input: [area_group_insert_input!]!) {
      insert_area_group(objects: $input, on_conflict: {constraint: area_group_pkey, update_columns: [area_name, group_name, area_id, itsm_group_id, do_fastener_auto_order, do_fastener_monitoring, do_ink_auto_order, do_ink_monitoring, do_maintenance_auto_order, do_maintenance_monitoring, do_print_head_auto_order, do_print_head_monitoring, do_toner_auto_order, do_toner_monitoring, do_usage_collection, itsm_consumable_auto_fulfillment, itsm_long_life_consumable_auto_fulfillment]}) {
        affected_rows
      }
    }`,
  };

  public static UPDATE_ASSET_STATUS: any = {
    variables: {},
    query: `mutation ($ids: [uuid!]!, $last_upload_result: json!) {
      update_asset(
        where: { id: { _in: $ids } },
        _set: { last_upload_result: $last_upload_result }
      ) {
        affected_rows
      }
    }`,
  };

  public static CUSTOM_LABELS: any = {
    variables: {},
    query: `query customLabels($projectId: uuid!) {
      project(where: {id: {_eq: $projectId}}) {
        customHeaders: account_custom_labels
      }
    }`,
  };

  public static ADDRESS: any = {
    variables: {},
    query: `query address($projectId: uuid!) {
      project(where: {id: {_eq: $projectId}}) {
        billFromStructure: bill_from_structure
        billFromBPIDId:bill_from_bpid_id
        globalDealSettings: global_deal_settings {
          globalOpportunityId: global_opportunity_id
          c2cDeploymentCountry: c2c_deployment_country
        }
        country {
          countryId: country_id
          geoRegionId: geo_region_id
        }
        targetSystem: target_system
        extended_childrens(limit: 1) {
          contractDuration
          fromCurrency
          salesOrganization
          toCurrency
          validSorg
        }
        bill_to_address_id
        sold_to_address_id
        payer_address_id
        end_user_address_id
        bill_to_contact_id
        invoice_contact_id
        hp_invoice_contact_id
        hp_sales_rep_contact_id
        hp_contract_admin_contact_id
        hp_acc_delivery_mgr_contact_id
        id
        isMpc: is_mpc
        status
        itsmCustomerId: itsm_customer_id
        resellerCustomerId: reseller_customer_id
        rejected
        coTerminous: co_terminous
        sourceDocumentationLink: source_documentation_link
        resellerBpId: reseller_bpid
        customerBpId: customer_bpid
        mpcContactsAddressesBpids: mpc_contacts_addresses_bpids
        defaultContractAccountId: default_contract_account_id
        orderAcceptance: order_acceptance
        orderAcceptanceCompleteDate: order_acceptance_complete_date
        billingFrequency: billing_frequency
        billingCycle: billing_cycle
        currency
        maStartDate: master_agreement_start_date
        saLetter: sa_letter
        coTerminousDate: co_terminous_date
        legacyReportedDate: legacy_reported_date
        billingStart: billing_start
        purchaseOrderSplit: purchase_order_split
        csa
        ampId: amp_id
        opportunityId: opportunity_id
        customerErpNumber: customer_erp_number
        opgNumber: opg_number
        vendorContractAccNumber: vendor_contract_acc_number
        commercialityCode: commerciality_code
        globalDealClassification: global_deal_classification
        dorData: dor_data
        initialBillingDate: initial_billing_day
        orderAcceptanceDisableReason: order_acceptance_disable_reason
        billingModelSplit: billing_model_split
        businessModelSplit: business_model_split
        chargeTypeSplit: charge_type_split
        globalDeal: global_deal
        podRequired: pod_required
        endUserSplit: end_user_split
        titleStatusSplit: title_status_split
        currentMaStatus: cur_master_agreement_status
        lastMAStatus: last_ma_return_status(path: "$.lastMAStatus")
        salesOrganization: sales_organization
        enableCatalogPricing: enable_catalog_pricing
        inadvanceInarrears: inadvance_inarrears
        supplyRoutingId: supply_routing_id
        customerBuildingAddress {
          id
          name1
          name2
          line1
          line2
          city
          country
          region
          postalCode
          customShippingLabel1
          customShippingLabel2
          deliveryType
          itsmImported
          businessPartnerId
          itsmSiteId
          itsmSiteName
          itsmBuildingId
          itsmBuilding
          buildingTypes: building_types
          types
        }
        partnerBuildingAddress {
          id
          name1
          name2
          line1
          line2
          city
          country
          region
          postalCode
          customShippingLabel1
          customShippingLabel2
          deliveryType
          itsmImported
          businessPartnerId
          itsmSiteId
          itsmSiteName
          itsmBuildingId
          itsmBuilding
          buildingTypes: building_types
          types
          updated_at
        }
      }
    }`,
  };

  public static SITE_DETAILS: any = {
    variables: {},
    query: `query siteDetails($siteId: uuid) {
      site(where: {id: {_eq: $siteId}}) {
        billToContactId: bill_to_contact_id
        invoiceContactId: invoice_contact_id
        hpInvoiceContactId: hp_invoice_contact_id
        hpSalesRepContactId: hp_sales_rep_contact_id
        hpContractAdminContactId: hp_contract_admin_contact_id
        hpAccDeliveryMgrContactId: hp_acc_delivery_mgr_contact_id
        physicalAddressId: site_address_id
        tonerAddressId: toner_address_id
        serviceAddressId: service_address_id
        hpInstalledKit: hp_installed_kit
        tmcSiteName: name
        address {
          siteId: itsm_site_id
        }
        project {
          billToContactId: bill_to_contact_id
          invoiceContactId: invoice_contact_id
          hpInvoiceContactId: hp_invoice_contact_id
          hpSalesRepContactId: hp_sales_rep_contact_id
          hpContractAdminContactId: hp_contract_admin_contact_id
          hpAccDeliveryMgrContactId: hp_acc_delivery_mgr_contact_id
          area_groups {
            id
            groupName: group_name
            areaName: area_name
          }
          target_system
          cur_master_agreement_status
          partnerContractAccounts {
            contract_accounts
          }
          customerContractAccounts {
            contract_accounts
          }
          defaultCustomShippingLabel1: custom_label_1
          defaultCustomShippingLabel2: custom_label_2
          opportunityId: opportunity_id
        }
      }
    }`,
  };

  public static SITE_ADDRESS: any = {
    variables: {},
    query: `query siteBuildingAddress($siteId: String) {
      settableAddresses: building_address(distinct_on:itsmBuilding
        where:{
          itsmSiteId:{
            _eq:$siteId
          }
        }){
          itsmSiteName
                  buildingTypes: building_types
                  itsmSiteId
                  itsmBuilding
                  itsmName: itsmBuilding
                  itsmBuildingId
                  customShippingLabel1
                  customShippingLabel2
                  deliveryType
                  name1
                  name2
                  line1
                  line2
                  city
                  region
                  postalCode: postalCode
                  country: country
                  businessPartnerId: businessPartnerId
                  id
        }
    }`,
  };

  public static PROJECT_SITES: any = {
    variables: {},
    query: `query individualSite($projectId: uuid!) {
      site(where: {project_id: {_eq: $projectId}}) {
        address {
          siteId: itsm_site_id
        }
      }
    }`,
  };

  public static MPC_SITE_ADDRESS: any = {
    variables: {},
    query: `query siteBuildingAddress($siteId: [String!]) {
      settableAddresses: building_address(distinct_on:itsmBuilding
        where:{
          itsmSiteId:{
            _in: $siteId
          }
        }){
          itsmSiteName
                  buildingTypes: building_types
                  itsmSiteId
                  itsmBuilding
                  itsmName: itsmBuilding
                  itsmBuildingId
                  customShippingLabel1
                  customShippingLabel2
                  deliveryType
                  name1
                  name2
                  line1
                  line2
                  city
                  region
                  postalCode: postalCode
                  country: country
                  businessPartnerId: businessPartnerId
                  id
        }
    }`,
  };

  public static SITE_IMPORT: any = {
    variables: {},
    query: `query importSite($projectId: uuid!) {
      project(where: {id: {_eq: $projectId}}) {
        country_id
        global_deal_classification
        global_deal_settings {
          c2c_deployment_country
        }
        area_groups {
          id
        }
        associate_sites: sites {
          site_address_id
        }
        sites: siteBuildingAddress(distinct_on: itsmBuildingId) {
          id
          building_types
          bpId: businessPartnerId
          itsmBuildingId: itsmBuildingId
          city
          country_id: country
          zipCode: postalCode
          itsmSiteId: itsmSiteId
          itsmSiteName: itsmSiteName
          itsmBuildingName: itsmBuilding
          shippingLabel1: customShippingLabel1
          shippingLabel2: customShippingLabel2
          address: line1
          regionByRegion {
            name
          }
        }
      }
    }`,
  };

  public static SAVE_SITE: any = {
    variables: {},
    query: `mutation ($input: [site_insert_input!]!) {
      insert_site(objects: $input, on_conflict: {constraint: site_pkey, update_columns: [id, name, k2_name, default_area_group_id, site_address_id, service_address_id, toner_address_id, project_id]}) {
        returning{
          id
        }
      }
    }`,
  };

  public static PARTNER_CONTACTS: any = {
    variables: {},
    query: `query contacts($encryptkey: String, $projectId: uuid!) {
      contacts: partnercontacts(args: {encryptkey: $encryptkey, projectid: $projectId}) {
        reseller_customer_id
        account_id
        related_account_ids
        id
        emailAddress: email_address
        lastName: last_name
        firstName: first_name
        businessPartnerId: business_partner_id
        country: country_id
        contactTypes: contact_types
        isHpContact: is_hp_contact
        itsmContactId: itsm_contact_id
        sourceSystem: source_system
        phoneNumber: phone_number
        phoneNumber2: phone_number2
        locale
        language: language_id
      }
    }`,
  };

  public static PARTNER_CONTACTS_WITH_ACTIVE_FILTER: any = {
    variables: {},
    query: `query contacts($encryptkey: String, $projectId: uuid!) {
      contacts: partnercontacts(args: {encryptkey: $encryptkey, projectid: $projectId},
      where: {is_inactive_for_account: {_eq: false}}) {
        reseller_customer_id
        account_id
        related_account_ids
        id
        emailAddress: email_address
        lastName: last_name
        firstName: first_name
        businessPartnerId: business_partner_id
        country: country_id
        contactTypes: contact_types
        isHpContact: is_hp_contact
        itsmContactId: itsm_contact_id
        sourceSystem: source_system
        phoneNumber: phone_number
        phoneNumber2: phone_number2
        locale
        language: language_id
      }
    }`,
  };

  public static CUSTOMER_CONTACTS: any = {
    variables: {},
    query: `query contacts($encryptkey: String, $projectId: uuid!) {
      contacts: customercontacts(args: {encryptkey: $encryptkey, projectid: $projectId}) {
        reseller_customer_id
        account_id
        related_account_ids
        id
        emailAddress: email_address
        lastName: last_name
        firstName: first_name
        businessPartnerId: business_partner_id
        country: country_id
        contactTypes: contact_types
        isHpContact: is_hp_contact
        itsmContactId: itsm_contact_id
        sourceSystem: source_system
        phoneNumber: phone_number
        phoneNumber2: phone_number2
        locale
        language: language_id
      }
    }`,
  };

  public static CUSTOMER_CONTACTS_WITH_ACTIVE_FILTER: any = {
    variables: {},
    query: `query contacts($encryptkey: String, $projectId: uuid!) {
      contacts: customercontacts(args: {encryptkey: $encryptkey, projectid: $projectId},
      where: {is_inactive_for_account: {_eq: false}}) {
        reseller_customer_id
        account_id
        is_inactive_for_account
        related_account_ids
        id
        emailAddress: email_address
        lastName: last_name
        firstName: first_name
        businessPartnerId: business_partner_id
        country: country_id
        contactTypes: contact_types
        isHpContact: is_hp_contact
        itsmContactId: itsm_contact_id
        sourceSystem: source_system
        phoneNumber: phone_number
        phoneNumber2: phone_number2
        locale
        language: language_id
      }    
    }`,
  }

  public static GLOBAL_OPP_ID: any = {
    variables: {},
    query: `query globalDeal($projectId: uuid) {
      global_deal_settings(where: {project_id: {_eq: $projectId}}) {
        customer_opportunity_group_id
        global_opportunity_id
      }
    }`,
  };

  public static MULTI_SITE_FILE_STAUS: any = {
    variables: {},
    query: `query mdfExportStatus($projectId: uuid!) {
      multisite_export_status(where: {project_id: {_eq: $projectId}}) {
        file_url
        file_status
        updated_at
      }
    }`,
  };

  public static MULTI_SITE_UPDATE: any = {
    variables: {},
    query: `mutation updatemdfstatus($input: multisite_export_status_insert_input!, $projectId: uuid!) {
      insert_multisite_export_status_one(object: $input, on_conflict: {constraint: multisite_export_status_pkey, update_columns: [file_status], where: {project_id: {_eq: $projectId}}}) {
        project_id
      }
    }`,
  };

  public static GET_INITIAL_PAGE_COUNT: any = {
    variables: {},
    query: `query GetInitialPageCount($assetIds: [uuid!]!) {
      asset(where: {id: {_in: $assetIds}}) {
        id
        initial_page_count
        install_date
        last_upload_result
      }
    }`,
  };

  public static COUNTRY_BY_GEO_REGION: any = {
    variables: {
    },
    query: `query getCountryByGeoRegion($geoRegionId: String!) {
      country(where: {geo_region_id: {_eq: $geoRegionId}}) {
        country_name
        country_id
      }
    }`,
  };
}
